// TODO(IL, 2024-12-03): this is a quick fix magic solution for the problem where
// we want to magically supply input data to certain special code task input keys,
// ie as ReferenceData rather than TaskOutput.
// Perhaps we will later add a "Reference Data Node" feature or otherwise allow
// the user to specify this.
export const isMagicallyPopulatedDataInputKey = (dataKey: string): boolean =>
  [
    'run_id',
    // other magic dataKeys go here if we have any
  ].includes(dataKey);
